'use client';

import React, { useEffect } from 'react';
import { captureReferralFromUrl } from '../../lib/referral';
import { captureClickIdsFromUrl } from '../../lib/clickIds';
import { captureAttributionFromLanding } from '../../lib/attribution';
import { loadPosthogWhenIdle } from '../../lib/posthog-lazy';
import { CartProvider } from '../../context/CartContext';
import { CurrencyProvider } from '../../context/CurrencyContext';
import { CookieConsentProvider } from '../../context/CookieConsentContext';
import { ThemeProvider } from '../../theme/ThemeProvider';
import { AuthProvider } from '../../context/AuthContext';
import { WishlistProvider } from '../../context/WishlistContext';

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: Readonly<ProvidersProps>) {
  useEffect(() => {
    captureReferralFromUrl();
    captureClickIdsFromUrl();
    captureAttributionFromLanding();
    loadPosthogWhenIdle();
  }, []);

  return (
    <ThemeProvider>
      <CookieConsentProvider>
        <CurrencyProvider>
          <AuthProvider>
            <WishlistProvider>
              <CartProvider>
                {children}
              </CartProvider>
            </WishlistProvider>
          </AuthProvider>
        </CurrencyProvider>
      </CookieConsentProvider>
    </ThemeProvider>
  );
}
